var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdPersistence } from "../../constants/IdPersistence";
import { utilEnvironment } from "../utilEnvironment";
import { utilPersistence } from "../utilPersistence";
import { IdLogging } from "./IdLogging";
import { LoggingConfigDefault } from "./LoggingConfigDefault";
import { LoggingStyles } from "./LoggingStyles";
var styleFromId = function (id) {
    var styles = LoggingStyles[id] || {};
    return Object.keys(styles).reduce(function (acc, key) { return key + ": " + styles[key] + "; " + acc; }, "");
};
var defaultOptions = {
    id: IdLogging.Default,
    prefix: "Unset",
};
var UtilLog = /** @class */ (function () {
    function UtilLog(options) {
        var _this = this;
        // tslint:disable-next-line
        this.log = function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            return _this.print.apply(_this, [console.log].concat(rest));
        };
        // tslint:disable-next-line
        this.warn = function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            return _this.print.apply(_this, [console.warn].concat(rest));
        };
        // tslint:disable-next-line
        this.error = function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            return _this.print.apply(_this, [console.error].concat(rest));
        };
        this.print = function (loggingFunc) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            if (utilEnvironment.isProduction() || utilEnvironment.isTest()) {
                return;
            }
            var _a = _this.options, prefix = _a.prefix, id = _a.id;
            var config = UtilLog.getConfig();
            if (!config[id]) {
                return;
            }
            var style = styleFromId(id);
            loggingFunc.apply(console, [
                "%c " + prefix + " ",
                "border-radius: 50px; font-size: 11px; line-height: 2em; font-weight: bold; " + style
            ].concat(rest));
        };
        this.options = __assign({}, defaultOptions, options);
    }
    UtilLog.setConfig = function (config) {
        var fullConfig = __assign({}, LoggingConfigDefault, UtilLog.getConfig(), config);
        utilPersistence.setValue(IdPersistence.Logging, fullConfig);
    };
    UtilLog.getConfig = function () {
        return utilPersistence.getValue(IdPersistence.Logging, LoggingConfigDefault);
    };
    return UtilLog;
}());
export { UtilLog };
var _a = new UtilLog({
    prefix: "Default",
}), log = _a.log, warn = _a.warn, error = _a.error;
var _b = new UtilLog({
    id: IdLogging.NetworkIn,
    prefix: "\uD83D\uDCE9 Network",
}), logNetworkIn = _b.log, warnNetworkIn = _b.warn, errorNetworkIn = _b.error;
var _c = new UtilLog({
    id: IdLogging.NetworkOut,
    prefix: "\uD83D\uDCE4 Network",
}), logNetworkOut = _c.log, warnNetworkOut = _c.warn, errorNetworkOut = _c.error;
var _d = new UtilLog({
    id: IdLogging.Graphics,
    prefix: "\uD83C\uDFA8 Graphics",
}), logGraphics = _d.log, warnGraphics = _d.warn, errorGraphics = _d.error;
var _e = new UtilLog({
    id: IdLogging.Animation,
    prefix: "\uD83D\uDCA8 Animation",
}), logAnimation = _e.log, warnAnimation = _e.warn, errorAnimation = _e.error;
var _f = new UtilLog({
    id: IdLogging.LandingPages,
    prefix: "\uD83D\uDEEC Landing Pages",
}), logLandingPages = _f.log, warnLandingPages = _f.warn, errorLandingPages = _f.error;
var _g = new UtilLog({
    id: IdLogging.Shop,
    prefix: "\uD83D\uDCB0 Shop",
}), logShop = _g.log, warnShop = _g.warn, errorShop = _g.error;
var _h = new UtilLog({
    id: IdLogging.Sound,
    prefix: "\uD83C\uDFB5 Sound",
}), logSound = _h.log, warnSound = _h.warn, errorSound = _h.error;
var _j = new UtilLog({
    id: IdLogging.Store,
    prefix: "\uD83D\uDCBE Store",
}), logStore = _j.log, warnStore = _j.warn, errorStore = _j.error;
var _k = new UtilLog({
    id: IdLogging.Tracking,
    prefix: "\uD83D\uDCCA Tracking",
}), logTracking = _k.log, warnTracking = _k.warn, errorTracking = _k.error;
// Put out a warning for self-XSS
if (utilEnvironment.isProduction()) {
    // tslint:disable-next-line
    console.log("%cSTOP!", "background: black; color: red; font-size: x-large; text-align: center;");
    // tslint:disable-next-line
    console.log("%cThis feature is intended for developers, if you were told to post something here, there's a good chance someone is attempting to compromise your account.", "font-size: large; text-align: center;");
}
export { log, warn, error, logNetworkIn, warnNetworkIn, errorNetworkIn, logNetworkOut, warnNetworkOut, errorNetworkOut, logGraphics, warnGraphics, errorGraphics, logAnimation, warnAnimation, errorAnimation, logLandingPages, warnLandingPages, errorLandingPages, logShop, warnShop, errorShop, logSound, warnSound, errorSound, logStore, warnStore, errorStore, logTracking, warnTracking, errorTracking, };



//////////////////
// WEBPACK FOOTER
// ./src/utils/logging/logging.ts
// module id = 76
// module chunks = 3